export const FB_LINKS = {
  learningPhase: 'https://www.facebook.com/business/help/112167992830700?id=561906377587030',
}

export const GOOGLE_LINKS = {
  googleAdsGuide:
    'https://cheqessentials.zendesk.com/hc/en-us/articles/13354733883281#h_01GXXFBZ1C138N82FA9DZ0Z3DT',
}
